module.exports = __webpack_public_path__ + "static/media/whatsapp-icon.8b08a8e6.png";